import { useContext, useState } from 'react';
import Dialog from '@/components/Dialog';
import { Close as DeleteIcon } from '@mui/icons-material';
import { FormattedMessage } from 'react-intl';
import AdditionalConfigStateContext from '../../../AdditionalConfigStateContext';
import EditorIsReadonlyContext from '@/pages/EditorPage/ChallengeModelsEditor/EditorIsReadonlyContext';
import { IconButton } from '@mui/material';

type DeleteOptionProps = {
  optionKey: string;
};

const DeleteOption = ({ optionKey }: DeleteOptionProps) => {
  const [, setAdditionalConfig] = useContext(AdditionalConfigStateContext);
  const [confirmationDialogOpen, setConfirmationDialogOpen] = useState(false);

  const deleteOption = () => {
    setConfirmationDialogOpen(false);

    setAdditionalConfig(additionalConfig => {
      delete additionalConfig.options![optionKey];
    });
  };

  const editorIsReadonly = useContext(EditorIsReadonlyContext);

  return (
    <>
      <IconButton
        color="error"
        onClick={() => setConfirmationDialogOpen(true)}
        disabled={editorIsReadonly}
      >
        <DeleteIcon />
      </IconButton>
      <Dialog
        open={confirmationDialogOpen}
        onClose={() => setConfirmationDialogOpen(false)}
        dangerous
      >
        <Dialog.Title>
          <FormattedMessage id="editor.model_editor.field_editor.select_editor.opion.delete.title" />
        </Dialog.Title>
        <Dialog.Content>
          <Dialog.ContentText>
            <FormattedMessage id="editor.model_editor.field_editor.select_editor.opion.delete.text" />
          </Dialog.ContentText>
        </Dialog.Content>
        <Dialog.Actions>
          <Dialog.Actions.CancelButton
            onClick={() => setConfirmationDialogOpen(false)}
          />
          <Dialog.Actions.DeleteButton onClick={deleteOption} />
        </Dialog.Actions>
      </Dialog>
    </>
  );
};

export default DeleteOption;
